import { Route } from "react-router-dom";
import { APP_URLS } from "../../../utils/constant";
import RateAdminLorAdjustmentsScreen from "../../../container/RateAdminScreen/RateAdminLorAdjustmentsScreen";
import CreateRateAdminLorAdjustments from "../../../container/RateAdminScreen/RateAdminLorAdjustmentsScreen/CreateRateAdminLorAdjustments";

const RateAdminLorAdjustmentsRoutes = (access = {}) => {
  const { create, view, edit = false } = access;

  return (
    <>
      {!!view && (
        <Route
          path={APP_URLS.RATEADMIN_LOR_ADJUSTMENTS.HOME}
          element={
            <RateAdminLorAdjustmentsScreen screenPermissions={access} />
          }
        />
      )}
      {!!create && (
        <Route
          path={APP_URLS.RATEADMIN_LOR_ADJUSTMENTS.CREATE}
          element={<CreateRateAdminLorAdjustments />}
        />
      )}
      {!!edit && (
        <Route
          path={APP_URLS.RATEADMIN_LOR_ADJUSTMENTS.EDIT}
          element={<CreateRateAdminLorAdjustments isEdit={true} />}
        />
      )}
    </>
  );
};

export default RateAdminLorAdjustmentsRoutes;
